import React, { createContext, useContext, useRef, ReactNode } from "react";
import { UseMutationResult } from "@tanstack/react-query";

type DeleteReservationMutation = UseMutationResult<void, unknown, number>;

interface MutationsContextType {
  deleteReservationMutation: DeleteReservationMutation | null;
  setDeleteReservationMutation: (mutation: DeleteReservationMutation) => void;
}

const MutationsContext = createContext<MutationsContextType | undefined>(
  undefined
);

interface MutationsProviderProps {
  children: ReactNode;
}

export const MutationsProvider: React.FC<MutationsProviderProps> = ({
  children,
}) => {
  const deleteReservationMutationRef =
    useRef<DeleteReservationMutation | null>(null);

  const setDeleteReservationMutation = (
    mutation: DeleteReservationMutation
  ) => {
    deleteReservationMutationRef.current = mutation;
  };

  const value: MutationsContextType = {
    deleteReservationMutation: deleteReservationMutationRef.current,
    setDeleteReservationMutation,
  };

  return (
    <MutationsContext.Provider value={value}>
      {children}
    </MutationsContext.Provider>
  );
};

export const useMutations = (): MutationsContextType => {
  const context = useContext(MutationsContext);
  if (context === undefined) {
    throw new Error(
      "useMutations debe ser usado dentro de un MutationsProvider"
    );
  }
  return context;
};

export const useDeleteReservationMutation = () => {
  const { deleteReservationMutation, setDeleteReservationMutation } =
    useMutations();
  return { deleteReservationMutation, setDeleteReservationMutation };
};
